/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pnav_ItemsInputs */

const en_pnav_items = /** @type {(inputs: Pnav_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_pnav_items = /** @type {(inputs: Pnav_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgänge`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Pnav_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pnav_items = /** @type {((inputs?: Pnav_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pnav_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pnav_items(inputs)
	return en_pnav_items(inputs)
});